import { Box } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap } from "../../common";
import Table from "../../../DocLayout/Table";
import CodeSnippet from "../../../components/CodeSnippet";
import ContentWrap from "../../../DocLayout/Content/Index";
import { APP_COIN_ASSET, APP_COIN_ASSETLIST } from "../../../config";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { codeMap } from "@/PageCodeComponents/MerchantAPPModelAPI";
import PostRequest from "@/components/PostRequest";
export default function Index() {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  return (
    <div>
      {/* 获取商家资产列表 */}
      <ContentWrap
        id="api-domumentation"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            {currentLang?.value === "en" && (
              <Box id="balance-query-apis" className="title">
                {translate("merchant_app_mode_API.text_1")}
              </Box>
            )}
            {currentLang?.value !== "en" && (
              <Box id="balance-query-apis" className="title_0">
                {translate("merchant_app_mode_API.text_2")}
              </Box>
            )}
            <Box className="title_1" id="get-balance-list">
              {translate("merchant_app_mode_API.text_3")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_4")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_COIN_ASSETLIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              isEmpty={true}
              isEmptyText={translate("common.no_requset_param")}
              tableData={[]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["asset_list"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取商家资产列表 返回*/}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.assets",
                  type: "Array",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_assets"
                  )}`,
                },
                {
                  name: "data.assets[index].coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "data.assets[index].coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "data.assets[index].available",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_number"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["asset_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取商家代币资产 */}
      <ContentWrap
        id="get-coin-balance"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("merchant_app_mode_API.text_6")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_7")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_COIN_ASSET} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["coin_asset"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取商家代币资产 返回*/}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.asset",
                  type: "Object",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_assets"
                  )}`,
                },
                {
                  name: "data.asset.coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "data.asset.coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "data.asset.available",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_number"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["coin_asset"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
